import { useEffect } from 'react'
import { useMutationConsentPreferences } from '@/features/account/services/Preferences/mutations'
import { useUser } from '@/features/account/services/User/hooks'
import { useConsentManager } from '@/lib/transcend/useConsentManager'
import { type ConsentChangeEventPayload } from '@transcend-io/airgap.js-types'
import { getIsConsentedToAnalytics } from '@/lib/transcend/utils'
import ShiptAnalytics from '@shipt/analytics-member-web'
import { trackSegmentConsentPreferenceUpdated } from '@/features/shared/analytics/transcend'

export const useConsentChangeListener = () => {
  const userId = useUser()?.id ?? 0
  const { airgap } = useConsentManager()
  const { mutate } = useMutationConsentPreferences()

  useEffect(() => {
    if (airgap?.addEventListener) {
      const listener = (event: Event | ConsentChangeEventPayload) => {
        if (!('detail' in event)) return

        const changes = event.detail.changes
        if (!changes) return

        trackSegmentConsentPreferenceUpdated()

        if (userId) {
          mutate({ userId, purposes: changes })
        }

        if (getIsConsentedToAnalytics()) {
          ShiptAnalytics.flush(1)
        }
      }

      airgap.addEventListener('consent-change', listener)

      return () => {
        airgap.removeEventListener('consent-change', listener)
      }
    }
  }, [airgap, userId, mutate])
}
